import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../../styles/pages.css";
import bg1 from "../../assets/images/bg1.png";
import bg2 from "../../assets/images/bg2.png";
import bg3 from "../../assets/images/bg3.png";
import logo from "../../assets/images/logo1.png";
import arrow from "../../assets/images/arrow.png";
import newsImage from "../../assets/images/newthumb.png";
import { getListMainNotice, getPopup } from "../../api";

const ImagePopup = ({ imageUrl, linkUrl, onClose }) => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // 쿠키 확인하여 팝업 표시 여부 결정
    const checkCookie = () => {
      const popupHidden = document.cookie.split("; ").find((row) => row.startsWith("popupHidden="));

      if (!popupHidden) {
        setIsVisible(true);
      }
    };

    checkCookie();
  }, []);

  // 팝업 닫기
  const closePopup = () => {
    setIsVisible(false);
    onClose && onClose();
  };

  // 1일간 보지 않기
  const hidePopupForDay = () => {
    const date = new Date();
    date.setTime(date.getTime() + 24 * 60 * 60 * 1000); // 1일 후
    document.cookie = `popupHidden=true; expires=${date.toUTCString()}; path=/`;
    closePopup();
  };

  if (!isVisible) return null;
  return (
    <div className="popup-overlay">
      <div className="popup-container">
        <div className="popup-content">
          <a href={linkUrl} target="_blank" rel="noopener noreferrer">
            <img src={imageUrl} alt="팝업 이미지" className="popup-image" />
          </a>
        </div>
        <div className="popup-buttons">
          <button onClick={hidePopupForDay} className="popup-button">
            1일간 보지 않기
          </button>
          <button onClick={closePopup} className="popup-button">
            닫기
          </button>
        </div>
      </div>
    </div>
  );
};
const Home = () => {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  // const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [card_notices, setCardNotices] = useState([]);
  const [list_notices, setListNotices] = useState([]);
  const [popups, setPopups] = useState([]);
  const [showPopup, setShowPopup] = useState(true);

  const slides = [
    {
      image: bg1,
      title: "시설 온실의 미래는\n에코텍글로벌이 열어가겠습니다",
      subtitle: "시설 농가의 소득증대와 온실관리의 편의를 도모하기 위해 뛰고 또 뛰는 에코텍글로벌이 되겠습니다",
    },
    {
      image: bg2,
      title: "시설 온실의 미래는\n에코텍글로벌이 열어가겠습니다",
      subtitle: "시설 농가의 소득증대와 온실관리의 편의를 도모하기 위해 뛰고 또 뛰는 에코텍글로벌이 되겠습니다",
    },
    {
      image: bg3,
      title: "시설 온실의 미래는\n에코텍글로벌이 열어가겠습니다",
      subtitle: "시설 농가의 소득증대와 온실관리의 편의를 도모하기 위해 뛰고 또 뛰는 에코텍글로벌이 되겠습니다",
    },
  ];
  useEffect(() => {
    (async () => {
      const res = await getListMainNotice();
      const data = res.data;
      setCardNotices(data.card_notices);
      setListNotices(data.list_notices);

      const resp = await getPopup();
      setPopups(resp.data.results);
    })();
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const handleNewsClick = (link) => {
    if (link) {
      window.open(link, "_blank", "noopener,noreferrer");
    }
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <>
      {popups.map((popup, index) => (
        <div className="popup">{showPopup && <ImagePopup imageUrl={popup.image_url} linkUrl={popup.link_url} onClose={() => setShowPopup(false)} />}</div>
      ))}
      <div className="main">
        <div className="slider-container">
          {slides.map((slide, index) => (
            <div key={index} className={`slide ${index === currentSlide ? "active" : ""}`} style={{ backgroundImage: `url(${slide.image})` }}>
              <div className="mainSection-1">
                <p>
                  {slide.title.split("\n").map((line, i) => (
                    <React.Fragment key={i}>
                      {line}
                      {i < slide.title.split("\n").length - 1 && <br />}
                    </React.Fragment>
                  ))}
                </p>
                <p>{slide.subtitle}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="slider-indicators">
          {slides.map((_, index) => (
            <button key={index} className={`indicator ${index === currentSlide ? "active" : ""}`} onClick={() => goToSlide(index)} />
          ))}
        </div>
      </div>
      <div className="mainSectionbg-2">
        <div className="container">
          {/* 에코텍글로벌 소개 섹션 */}
          <div className="intro-section">
            <div className="logo-container">
              <img src={logo} alt="ECOTECH GLOBAL" className="ecofarm-logo" />
            </div>
            <h2 className="intro-title">에코텍글로벌은 농업 인프라를 만듭니다</h2>
            <p className="intro-subtitle">시설 농가의 소득증대와 온실관리의 편의를 도모하기 위해 뛰고 또 뛰는 에코텍글로벌이 되겠습니다</p>
            <div className="intro-content">
              <p>에코텍글로벌은 현장의 목소리로부터 출발합니다.</p>
              <p>
                국내 온실 규모·기후·작물 특성에 맞춘 맞춤 시공법을 연구하고
                <br />
                200여 명의 전문 엔지니어를 직접 양성해 전국에 배치했습니다.
              </p>
              <p>
                앞으로도 '뛰고 또 뛰는' 자세로 농가 소득 증대와
                <br />
                편리한 온실 관리를 위한 혁신을 이어가겠습니다.
              </p>
            </div>
            <Link to="/about/greeting" className="more-btn" onClick={scrollToTop}>
              더 알아보기 <img src={arrow} alt="더보기" className="arrow" />
            </Link>
          </div>
          {/* Products 섹션 */}
          <div className="products-section">
            <h3 className="products-title">products</h3>
            <div className="products-grid">
              <div className="product-card">
                <div className="product-content">
                  <div className="product-content-row">
                    <h4>온실시공</h4>
                    <p>
                      고단열·고내구 자재를 사용해
                      <br />
                      에너지 비용을 줄이고 작물 생산성을 극대화합니다.
                    </p>
                  </div>
                  <Link to="/products/construction" className="product-btn" onClick={scrollToTop}>
                    더 알아보기 <img src={arrow} alt="더보기" className="arrow" />
                  </Link>
                </div>
              </div>
              <div className="product-card">
                <div className="product-content">
                  <div className="product-content-row">
                    <h4>차광/세척제</h4>
                    <p>
                      분사-세척 겸용으로 작업 시간을 줄이고
                      <br />
                      유지관리 비용을 최소화합니다.
                    </p>
                  </div>
                  <Link to="/products/sanitizer" className="product-btn" onClick={scrollToTop}>
                    더 알아보기 <img src={arrow} alt="더보기" className="arrow" />
                  </Link>
                </div>
              </div>
              <div className="product-card">
                <div className="product-content">
                  <div className="product-content-row">
                    <h4>작물파쇄</h4>
                    <p>
                      수확 후 잔재를 초미분 파쇄해
                      <br />
                      퇴비화 속도를 높이고 부산물 처리 비용을 절감합니다.
                    </p>
                  </div>
                  <Link to="/products/shredder" className="product-btn" onClick={scrollToTop}>
                    더 알아보기 <img src={arrow} alt="더보기" className="arrow" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* News 섹션 */}
      <div className="news-section">
        <div className="container">
          <h3 className="news-title">news</h3>
          <div className="news-grid">
            <div className="news-featured">
              {card_notices.map((notice, index) => (
                <div className="news-card large" onClick={() => handleNewsClick(notice.link)}>
                  <div className="news-image">
                    <img src={newsImage} alt="에코텍글로벌 뉴스" />
                  </div>
                  <div className="news-content">
                    <p className="news-text">{notice.title}</p>
                    <p className="news-date">{new Date(notice.created_at).toISOString().split("T")[0]}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="news-list">
              {list_notices.map((notice, index) => (
                <div key={index} className="news-item" onClick={() => handleNewsClick(notice.link)}>
                  <p className="news-text">{notice.title}</p>
                  <p className="news-date">{new Date(notice.created_at).toISOString().split("T")[0]}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
